"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
require("./point-links-sk");
